import { defineStore } from 'pinia';
import { onRequestDefaultError, requests, removeNulls } from '🔗/utils/requests';

const useTgsApi = defineStore('tgs-api', {
    state: () => ({
        collections: [],
        collection: {}
    }),
    actions: {
        async getCollections() {
            if (this.collections?.length) {
                return this.collections;
            }

            try {
                const response = await fetch(`${import.meta.env.VITE_APP_TGS_URL}/index.json`);
                    
                if (!response.ok) {
                    throw new Error(response.status);
                }

                const result = await response.json();
                if (result?.length) {
                    this.collections = result;
                    return result
                }

                return [];
            } catch (e) {
                // onRequestDefaultError(e);
            }
        },
        async getCollection(code) {
            if (this.collection[code]) {
                return this.collection[code];
            }

            try {
                const response = await fetch(`${import.meta.env.VITE_APP_TGS_URL}/${code}/index.json`);
                    
                if (!response.ok) {
                    throw new Error(response.status);
                }

                const result = await response.json();
                if (result?.length) {
                    this.collection[code] = result;
                    return result
                }

                return [];
            } catch (e) {
                // onRequestDefaultError(e);
            }
        }
    }
});

export default useTgsApi;
